exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".common_form_search[data-v-58de782f]{padding:15px 30px 0}.child_page[data-v-58de782f]{padding-bottom:15px}.goods_info .info[data-v-58de782f]{margin-left:10px}.goods_info .info p[data-v-58de782f]{color:#666666}.goods_info .info p[data-v-58de782f]:first-child{color:#999999}.activity[data-v-58de782f]{line-height:24px}.activity span[data-v-58de782f]{width:20px;height:20px;margin-left:10px}\n", ""]);

// exports
